module.exports = __webpack_public_path__ + "static/media/p6.b651fa12.jpeg";